import React, {Component} from 'react';
import Pagination from '../../HelperComponents/Pagination/Pagination';
import NoItems from '../../HelperComponents/NoItems/NoItems';
import moment from "moment/moment";
import TransactionsBalance from '../TransactionsBalance';

import { splitByCommas } from "../../../helpers/functions";

import './TransactionsTable.scss';
import OrdersIcon from "../../../assets/image/no_orders.png";
import { Link } from 'react-router-dom';

const hasAmount = value => value != null && Number.isFinite(Number(value)) && Number(value) !== 0;

class TransactionsTable extends Component {
    getCompanyId = (company = '') => {
        const { all_companies } = this.props;
        const match = Array.isArray(all_companies) && all_companies.find(item => item.company === company);
        return match ? match.id : undefined;
    };

    render(){
        const { activePage, all_transactions = {}, linkType, onChangePage } = this.props;
        const { results = {}, count = 0 } = all_transactions;
        const today = moment().format('YYYY-MM-DD');

        return (
            <div className="transactions_table_wrapper">
                <div className="transactions_table">
                    <div className={`table_container transactions_columns${linkType ? '' : ' transactions_columns--company'}`}>
                        {!linkType && (
                            <div className="transactions_company_totals">
                                <TransactionsBalance balance={results.balance_total} overdue={results.overdue_total} />
                            </div>
                        )}
                        <div className="table_header">
                            <div className="table_row">
                                <div className="row_item">Дата/время</div>
                                <div className="row_item">Компания</div>
                                <div className="row_item">Сумма</div>
                                <div className="row_item">Тип транзакции</div>
                                <div className="row_item">Номер выдачи заказа</div>
                                {linkType ? (
                                    <div className="row_item">Просроченная задолженность</div>
                                ) : (
                                    <React.Fragment>
                                        <div className="row_item">Срок оплаты</div>
                                        <div className="row_item">Осталось оплатить</div>
                                    </React.Fragment>
                                )}
                                <div className="row_item">Баланс</div>
                            </div>
                        </div>
                        <div className="table_body">
                            {count > 0 && results.transactions ?
                                results.transactions.map(item => {
                                    const Row = linkType ? Link : 'div';
                                    const rowProps = linkType ? { to: `/admin/transactions/${this.getCompanyId(item.company)}` } : {};
                                    const unpaidPurchase = item.type_transaction === 'Покупка товара' && hasAmount(item.remaining_to_pay);
                                    const dueDate = moment(item.payment_due_date, 'YYYY-MM-DD', true);
                                    // Compare calendar dates: a payment due today is not overdue.
                                    const overdue = dueDate.isValid() && item.payment_due_date < today;

                                    return (
                                        <Row {...rowProps} className="table_row" key={item.id}>
                                            <div className="row_item">{moment(item.date).format('DD.MM.YYYY HH:mm')}</div>
                                            <div className="row_item">{item.company}</div>
                                            <div className="row_item">
                                                <div className={item.type_transaction === 'Покупка товара' ? 'red_text' : 'green_text'}>
                                                    {splitByCommas(item.amount)} ₽
                                                </div>
                                            </div>
                                            <div className="row_item">{item.type_transaction}</div>
                                            <div className="row_item">{item.document_number}</div>
                                            {linkType ? (
                                                <div className="row_item">
                                                    {hasAmount(item.overdue_debt) && (
                                                        <span className="red_text">{splitByCommas(item.overdue_debt)} ₽</span>
                                                    )}
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    <div className="row_item">
                                                        {unpaidPurchase && dueDate.isValid() ? dueDate.format('DD.MM.YYYY') : null}
                                                    </div>
                                                    <div className="row_item">
                                                        {unpaidPurchase && (
                                                            <span className={overdue ? 'red_text' : 'green_text'}>
                                                                {splitByCommas(item.remaining_to_pay)} ₽
                                                            </span>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                            <div className="row_item">{splitByCommas(item.balance)} ₽</div>
                                        </Row>
                                    );
                                })
                                :
                                <NoItems>
                                    <div className="box-img"><img src={OrdersIcon} alt="edit icon"/></div>
                                    <div className="title">Транзакций не найдено</div>
                                </NoItems>
                            }
                        </div>
                    </div>
                    {count > 10 && (
                        <Pagination
                            active={activePage}
                            pageItemsCount={10}
                            pageTotalCount={count}
                            onChange={e => onChangePage(e.selected + 1)}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default TransactionsTable;
